export class GlobalNotification {
  id: number;
  notificationType: string;
  notificationTitle: string;
  notificationMessageContent: string;
  isActive: boolean;
  createDatetime: Date;
  createdBy: string;
  activeStartDatetime: Date;
  inactiveStartDatetime: Date;
  typePriority: number;
}
